export function getPath({ location: { pathname } }) {
  return pathname
    .split("/")
    .pop()
    .toLowerCase();
}
